export default __webpack_public_path__ + "static/media/POKI1@3x.265ec863.png";